// firebase
import { db } from "config/firebase";
import { collection, setDoc, doc } from "firebase/firestore";

// features/user
import addSignature from "features/user/addSignature";

// A ---------------------------------------------------------------------- M

const sendDataStream = async (userID, dataBody, timestamp, databoxID) => {
  try {
    const { uploadID, uploadedFiles, uploadProperties } = dataBody;
    const recordRef = doc(db, "recordsdata", uploadID);

    const recordData = {
      txid: uploadID,
      type: "CDNFile",
      tdr: databoxID,
      creator_uuid: userID,
      public: false,
      version: 1,
      timestamp,
      uploadID,
      AIC_ID: null,
      data: uploadedFiles,
      metadata: uploadProperties,
      ...uploadProperties,
    };

    await setDoc(recordRef, recordData);
    console.log("Record data saved:", recordData);

    const tagRef = doc(db, "tagsdata", databoxID);
    const recordsRef = collection(tagRef, "signatures");

    // Extract fields for the search index
    const { documenti, soggetti, extraMetadata } = uploadProperties;
    const documentNames = documenti.map((doc) => doc.nomeDocumento);
    const soggettiFullName = soggetti.filter((s) => s.tipoSoggetto === "PF").map((s) => `${(s.nome || "").trim()} ${(s.cognome || "").trim()}`.trim());
    const soggettiCodiceFiscale = soggetti.filter((s) => s.tipoSoggetto === "PF").map((s) => s.codiceFiscale || "");
    const soggettiOrganizzazione = soggetti.filter((s) => s.tipoSoggetto === "PG").map((s) => s.denominazioneOrganizzazione || "");

    // Process extra metadata into custom parameters
    const customParams = [];
    if (extraMetadata && typeof extraMetadata === "object") {
      Object.entries(extraMetadata).forEach(([key, value]) => {
        if (typeof value === "string" && value.trim()) {
          customParams.push(`${key.trim()}:${value.trim()}`);
        }
      });
    }

    const signatureData = {
      txid: uploadID,
      type: "CDNFile",
      creator_uuid: userID,
      public: false,
      db_id: 1,
      timestamp,
      uploadID,
      AIC_ID: null,
      metadata: uploadProperties,
      searchIndex: {
        documentNames,
        soggettiFullName,
        soggettiCodiceFiscale,
        soggettiOrganizzazione,
        customParams,
      },
      ...uploadProperties,
    };

    console.log("Signature data to save:", signatureData);
    await setDoc(doc(recordsRef, uploadID), signatureData);

    await addSignature(userID, uploadID, timestamp, "CDNFile", databoxID);

    const uploadStatusRef = doc(db, "uploadStatuses", uploadID);

    const uploadStatusData = {
      txid: uploadID,
    };

    console.log("Upload status data:", uploadStatusData);
    await setDoc(uploadStatusRef, uploadStatusData, { merge: true });

    const result = {
      txid: uploadID,
      success: true,
    };

    console.log(result);
    return result;
  } catch (err) {
    console.error("Error in sendDataStreamCDNFile:", err);
    return {
      success: false,
      error: err.message,
    };
  }
};

export default sendDataStream;
